<!--
  Side view of the provision type object. Compact form after cp-provision-agent-side.component.html:
  the master form is the default; a child list is rendered only when the frame explicitly selects
  that navItem via ?sideNavItem=.
-->
@if (initialized && dto) {

    <div class="cp-provision-type-side mt-3">

        @if (activeNavigationItem?.action == 'contractEvents') {
            <cp-provision-type-contract-event
                    [provisionTypeId]="objectIdentifier.objectId">
            </cp-provision-type-contract-event>
        } @else if (activeNavigationItem?.action == 'matrices') {
            <cp-provision-type-matrix
                    [provisionTypeId]="objectIdentifier.objectId">
            </cp-provision-type-matrix>
        } @else if (activeNavigationItem?.action == 'conditionSets') {
            <cp-provision-type-condition-set
                    [provisionTypeId]="objectIdentifier.objectId"
                    [focusConditionSetId]="focusConditionSetId"
                    (onFocusConditionSetConsumed)="onFocusConditionSetConsumed()">
            </cp-provision-type-condition-set>
        } @else if (activeNavigationItem?.action == 'matrixAssignments') {
            <cp-provision-type-matrix-assignment
                    [provisionTypeId]="objectIdentifier.objectId"
                    [child]="childTabs['matrixAssignments']"
                    (onJumpToConditionSet)="jumpToConditionSet($event)">
            </cp-provision-type-matrix-assignment>
        } @else if (activeNavigationItem?.action == 'componentEligibility') {
            <cp-provision-type-component-eligibility
                    [provisionTypeId]="objectIdentifier.objectId"
                    [child]="childTabs['componentEligibility']"
                    (onJumpToConditionSet)="jumpToConditionSet($event)">
            </cp-provision-type-component-eligibility>
        } @else if (activeNavigationItem?.action == 'calculatedAgents') {
            <cp-provision-type-calculated-agent
                    [provisionTypeId]="objectIdentifier.objectId"
                    [child]="childTabs['calculatedAgents']"
                    (onJumpToConditionSet)="jumpToConditionSet($event)">
            </cp-provision-type-calculated-agent>
        } @else if (activeNavigationItem?.action == 'configCheck') {
            <cp-config-check-panel
                    [provisionTypeId]="objectIdentifier.objectId">
            </cp-config-check-panel>
        } @else if (childTabs[activeNavigationItem?.action]) {
            <cp-provision-type-child-table
                    [provisionTypeId]="objectIdentifier.objectId"
                    [child]="childTabs[activeNavigationItem.action]"
                    (onJumpToConditionSet)="jumpToConditionSet($event)">
            </cp-provision-type-child-table>
        } @else {
            <cp-provision-type-base-data
                    [provisionTypeId]="objectIdentifier.objectId">
            </cp-provision-type-base-data>
        }

    </div>

}
